import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appSecondaryButtonWithBorder]',
    standalone: false
})
export class SecondaryButtonWithBorderDirective {
    @HostBinding('class') get classes(): string {
        return 'secondary-button-with-border';
    }
}
